module.exports = __webpack_public_path__ + "img/blue_009.2e4efa85.png";